import AbstractGroupItem from './abstractGroupItem';

/**
 * @class CombinedGroupItem
 * @extends AbstractGroupItem
 */
const CombinedGroupItem = AbstractGroupItem.extend({

    /**
     * Item type
     *
     * @property {String} type
     */
    type: 'CombinedGroup',

    defaults: {
        ...AbstractGroupItem.prototype.defaults,

        /**
         * @property {String} Type
         */
        type: 'CombinedGroup',
    },
});

export default CombinedGroupItem;
